import {Component, Input} from '@angular/core';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-home-why-card-orange',
  imports: [],
  templateUrl: './home-why-card-orange.component.html',
})
export class HomeWhyCardOrangeComponent {

  @Input()
  reduced = true
  protected readonly environment = environment;
}
